import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import scanStore from "@/store/scanStore";
import { loginStore } from "@/store/loginStore";
import PublicChristmas from "./PublicTemplates/Christmas";
import PublicProfile from "./PublicTemplates/Profile";
import PublicPostcard from "./PublicTemplates/Postcard";
import PublicTet from "./PublicTemplates/Tet";
import PublicQuoteOfTheDay from "./PublicTemplates/QuoteOfTheDay";
import PublicPet from "./PublicTemplates/Pet";
import PublicWebsite from "./PublicTemplates/Website";

export default function PublicView() {
  const { cusTemplate } = scanStore();
  const { token } = loginStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!cusTemplate || cusTemplate.status !== "published") {
      navigate("/not-found");
    }
  }, [cusTemplate, navigate]);

  if (!cusTemplate || cusTemplate.status !== "published") return null;

  const renderTemplate = () => {
    switch (cusTemplate.type) {
      case "christmas":
        return <PublicChristmas config={cusTemplate.config} />;
      case "tet":
        return <PublicTet config={cusTemplate.config} />;
      case "profile":
        return <PublicProfile config={cusTemplate.config} />;
      case "postcard":
        return <PublicPostcard config={cusTemplate.config} />;
      case "quote_of_the_day":
        return <PublicQuoteOfTheDay config={cusTemplate.config} />;
      case "pet":
        return <PublicPet config={cusTemplate.config} />;
      case "website":
        return <PublicWebsite config={cusTemplate.config} />;
      default:
        return (
          <div className="flex h-full items-center justify-center p-8 text-center text-gray-400">
            Template này chưa có giao diện hiển thị.
          </div>
        );
    }
  };

  return (
    <div className="relative">
      {renderTemplate()}

      {/* Edit button — luôn hiển thị, trừ website (tự redirect) */}
      {cusTemplate.type !== "website" && (
        <button
          onClick={() => {
            if (token) {
              navigate("/");
            } else {
              navigate("/login?redirect=/view");
            }
          }}
          title="Chỉnh sửa template"
          style={{
            position: "fixed",
            bottom: 24,
            right: 24,
            width: 34,
            height: 34,
            borderRadius: "50%",
            border: "none",
            background: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            boxShadow: "0 2px 12px rgba(0,0,0,0.25)",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            transition: "transform 0.2s ease, background 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.1)";
            e.currentTarget.style.background = "rgba(255,255,255,0.25)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.background = "rgba(255,255,255,0.15)";
          }}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
          </svg>
        </button>
      )}
    </div>
  );
}
